import { connect } from 'react-redux';
import { Preview } from '../../components/Preview/Preview';
import { IPreviewEvents, IPreviewField } from '../../components/Preview/types';
import { IApplicationState } from '../../../../../../../types/types';
import { IPreviewHOCProps } from './types';
import { onToggle } from './events/onToggle';
import { getPreviewSettingsCreateSelector } from './selectors/getPreviewSettings';
import { getSectionType } from '../../../../boardDetails/selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { onOpenSettings } from './events/onOpenSettings';

const mapStateToProps = () => {
    const getPreviewSettings = getPreviewSettingsCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { boardId }: IPreviewHOCProps
    ): IPreviewField => {
        const sectionType = getSectionType(state, boardId, null, 'allowBackupXml', 'allowCreateBackUp');
        return {
            boardId,
            isAdmin: sectionType !== ESettingsSectionType.DISALLOW && sectionType !== ESettingsSectionType.READONLY,
            settings: getPreviewSettings(state, boardId),
        };
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IPreviewHOCProps
): IPreviewEvents => {
    return {
        onOpenSettings: () => dispatch(onOpenSettings()),
        onToggle: (key) => dispatch(onToggle(boardId, key)),
    };
};

export const PreviewHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Preview);

PreviewHOC.displayName = 'PreviewHOC';
